export default "__VITE_ASSET__16751594__"